import { useMutation, useQueryClient } from '@tanstack/react-query'
import axios from '@pepper/utils/src/function/axiosInstance'
import extract from '@pepper/utils/src/function/extract'
import { BASE_URL } from '@pepper/utils/src/api/config'

type Payload = {
  role?: UserRole | null
  tags?: {
    user_tag_type_id: number
  }[]
  phone_ext?: number | null
  phone?: string | null
  social_media?: {
    linkedin: string | null | undefined
  }
  resume?: string
  sample_work?: string[]
  sample_work_links?: string[]
  freelancer_type?: string | null
  expected_pay?: string | null
  work_xp?: string | number
  verticals_provisional?: { id: number; preference: string }[]
  genres_provisional?: {
    id: number
    preference: '1' | '2'
  }[]
  editing_formats?: string[]
  education_details?: {
    degree_name_id: number | null | undefined
  }[]
  profession_categories?: (number | number[])[]
  translation_languages_target?: (number | number[])[]
  translation_languages_source?: (number | number[])[]
  pay_levels?: number[]
  general_remark?: string | null
  work_type?: number | null
  dashboard_notification_seen?: boolean
}

type Props = {
  body: Payload
  id?: string | null
}

export function useUpdateUserDetails() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ id, body }: Props) => {
      try {
        if (!id) throw new Error('Please login again')

        const response = await axios.put(
          `${BASE_URL}/users/${id}/details`,
          body
        )
        return {
          status: 'ok',
          id,
          description: response.data.description
        }
      } catch (error) {
        return {
          status: 'error',
          id,
          description: extract.error(error).error as string
        }
      }
    },
    onSuccess: ({ id }) => {
      queryClient.invalidateQueries({
        queryKey: [`/users/${id}/details`]
      })
    }
  })
}
